/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Breadcrumbs } from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';

import { getGatewayUrl } from 'shared-ui/utils/getGatewayUrl';
import QuestionnaireContainer from '../components/questionnaire/QuestionnaireContainer';
import * as pActions from '../actions/permit';

export class QuestionnairePage extends React.Component {
    static propTypes = {
        router: COMPAT_ROUTER_PROP_TYPES,
        dispatch: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.onCompletedResult = this.onCompletedResult.bind(this);
    }

    onCompletedResult(result) {
        if (result === 'overnight-hike') {
            const redirectURL = `/permits/233396/registration/detailed-availability?type=OvernightHike`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'overnight-paddle') {
            const redirectURL = `/permits/233396/registration/detailed-availability?type=OvernightPaddle`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'overnight-paddle-entry-71') {
            const redirectURL = `/permits/233396/registration/detailed-availability?type=CanadaPaddle&tab=1`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'overnight-motor-entry-71') {
            const redirectURL = `/permits/233396/registration/detailed-availability?type=CanadaMotor&tab=1`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'overnight-paddle-canada') {
            const redirectURL = `/permits/233396/registration/detailed-availability?type=CanadaPaddle`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'overnight-motor') {
            const redirectURL = `/permits/233396/registration/detailed-availability?type=OvernightMotor`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'day-use-motor') {
            const redirectURL = `/permits/233396/registration/detailed-availability?type=DayUseMotor`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'day-use-motor-to-canada') {
            this.props.dispatch(
                pActions.setQuestionnaireAnswers({ motorSpendNightOnWayToCanada: 'no' })
            );
            this.props.dispatch(
                pActions.setQuestionnaireAnswers({ motorSpendNightOnWayFromCanada: 'no' })
            );
            const redirectURL = `/permits/233396/registration/detailed-availability?type=CanadaMotor`;
            this.props.router.navigate(redirectURL);
        }
        if (result === 'overnight-motor-canada') {
            this.props.dispatch(
                pActions.setQuestionnaireAnswers({ motorSpendNightOnWayToCanada: 'yes' })
            );
            this.props.dispatch(
                pActions.setQuestionnaireAnswers({
                    motorSpendNightOnWayFromCanada: 'yes',
                })
            );
            const redirectURL = `/permits/233396/registration/detailed-availability?type=CanadaMotor`;
            this.props.router.navigate(redirectURL);
        }
    }

    render() {
        return (
            <div className="boundarywaters">
                <div className="permit-content-outer-wrap">
                    <div className="permit-content-wrap">
                        <div className="rec-nested-wrap">
                            <div className={'rec-grid-12-12'}>
                                <Breadcrumbs
                                    path={[
                                        { title: 'Home', url: '/' },
                                        {
                                            title: 'Superior National Forest',
                                            url: getGatewayUrl('1085'),
                                        },
                                        {
                                            title: 'Boundary Waters Canoe Area Wilderness',
                                            url: '/permits/233396',
                                        },
                                        { title: 'Walk Me Through' },
                                    ]}
                                />
                            </div>
                            <div id="page-content">
                                <QuestionnaireContainer
                                    onCompletedResult={this.onCompletedResult}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function select() {
    return {};
}

export default withCompatRouter(connect(select)(QuestionnairePage));
